export default class Vec2 {
	/**
	 * @param {number} x
	 * @param {number} y
	 */
	constructor(x, y) {
		/**
		 * @type {number}
		 */
		this.x = x;

		/**
		 * @type {number}
		 */
		this.y = y;
	}

	/**
	 * @param {Mat3} mat
	 * @returns {Vec2}
	 */
	transform(mat) {
		const x = this.x, y = this.y;
		const m = mat.values;
		
		this.x = x * m[0] + y * m[1] + m[2];
		this.y = x * m[3] + y * m[4] + m[5];
		return this;
	}
}
